"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productSortingProperties = exports.defaultSortingProperties = void 0;
const i18next_1 = __importDefault(require("i18next"));
const translation_1 = require("../../common/js/helper/translation");
const SortingPropertyModel_1 = require("../models/SortingPropertyModel");
const compare_1 = require("./compare");
const product_1 = require("./product");
const propertyCompare = (direction, propertyId, a, b) => {
    const propertyA = a.extensions?.massiveProperties?.find((p) => p.group?.id === propertyId);
    const propertyB = b.extensions?.massiveProperties?.find((p) => p.group?.id === propertyId);
    if (!propertyA) {
        return 1;
    }
    if (!propertyB) {
        return -1;
    }
    const compare = (0, compare_1.numericCompare)(i18next_1.default.language);
    if (SortingPropertyModel_1.SortingDirection.asc === direction) {
        return compare(propertyA.translated?.name ?? '', propertyB.translated?.name ?? '');
    }
    return compare(propertyB.translated?.name ?? '', propertyA.translated?.name ?? '');
};
const defaultSortingProperties = () => {
    const sorting = [
        {
            direction: SortingPropertyModel_1.SortingDirection.asc,
            key: 'name-asc',
            position: -2,
            property: 'name',
            type: SortingPropertyModel_1.SortingType.text,
            sort: (a, b) => (0, compare_1.localeCompare)(a.translated?.name ?? '', b.translated?.name ?? ''),
        },
        {
            direction: SortingPropertyModel_1.SortingDirection.desc,
            key: 'name-desc',
            position: -1,
            property: 'name',
            type: SortingPropertyModel_1.SortingType.text,
            sort: (a, b) => (0, compare_1.localeCompare)(b.translated?.name ?? '', a.translated?.name ?? ''),
        },
    ];
    if ((0, product_1.showPrices)()) {
        sorting.push({
            direction: SortingPropertyModel_1.SortingDirection.asc,
            key: 'price-asc',
            position: -4,
            property: 'price',
            type: SortingPropertyModel_1.SortingType.numeric,
            sort: (a, b) => (0, compare_1.priceCompare)(a, b),
        });
        sorting.push({
            direction: SortingPropertyModel_1.SortingDirection.desc,
            key: 'price-desc',
            position: -3,
            property: 'price',
            type: SortingPropertyModel_1.SortingType.numeric,
            sort: (a, b) => (0, compare_1.priceCompare)(b, a),
        });
    }
    return sorting;
};
exports.defaultSortingProperties = defaultSortingProperties;
const productSortingProperties = (products, sortableProperties) => {
    const propertyIds = sortableProperties.map((property) => property.propertyId);
    return (0, product_1.availablePropertyGroups)(products, propertyIds).flatMap((group) => {
        const property = sortableProperties.find((findProperty) => findProperty.propertyId === group.id);
        if (!property || !group.id) {
            return [];
        }
        return Object.values(SortingPropertyModel_1.SortingDirection).flatMap((direction) => {
            return {
                direction: direction,
                key: `${(group.translated?.name ?? '').replace(/\s+/, '-').toLowerCase()}-${direction}`,
                name: (0, translation_1.t)(`select.product_sort.direction.${direction}`, {
                    type: SortingPropertyModel_1.SortingType.text,
                    property: group.translated?.name ?? '',
                }),
                position: property.position,
                property: group.id,
                type: SortingPropertyModel_1.SortingType.text,
                sort: (a, b) => propertyCompare(direction, group.id, a, b),
            };
        });
    });
};
exports.productSortingProperties = productSortingProperties;
